module.exports = __webpack_public_path__ + "static/media/trips.ed956dd7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/trips.svg
// module id = 490
// module chunks = 0